var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedBenefit)?_c('div',[_c('BenefitShow',{key:_vm.selectedBenefit.id,attrs:{"benefit":_vm.selectedBenefit,"types":_vm.selectedBenefit.types}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }